import { Responses as QuestionResponses } from '@bighealth/types';
import { APIRequestBody, APIResponse } from '../../types';
import { api } from '../../api';
import { AxiosRequestConfig } from 'axios';

export const create_responses_for_questions = async (
  args: create_responses_for_questions.Args,
  requestConfig?: AxiosRequestConfig
): Promise<create_responses_for_questions.Response> => {
  const request: create_responses_for_questions.Request = {
    service_name: 'Response',
    service_version: '2',
    service_method: 'create_responses_for_questions',
    args,
  };

  return await api(request, requestConfig);
};

create_responses_for_questions.queryKey =
  'Response/create_responses_for_questions';

export declare namespace create_responses_for_questions {
  export type Args = QuestionResponses;

  export interface Request extends APIRequestBody {
    service_name: 'Response';
    service_version: '2';
    service_method: 'create_responses_for_questions';
    args: Args;
  }

  export type Result = {};

  export type Response = APIResponse<Result>;
}
